import { LocationOrAccountOptions, SortBy } from "app/consts";
import { IBloodDrive } from "types/IBloodDrive";
import { locationFilter } from "../../../../utils/filters/filterOperations/locationFilter";
import { dateFilter } from "../../../../utils/filters/filterOperations/dateFilter";
import { IOpportunitySearchFilter } from "../hooks/useOpportunitySearchFilter";
import {
   alphabeticalSorting,
   chronologicalOrder,
   distanceSorting,
} from "../../../../utils/sorting";

const appointmentTypeFilter = (
   item: IBloodDrive,
   appointmentTypes: string[],
): boolean => {
   try {
      if (appointmentTypes.length === 0) {
         return true;
      } else {
         let isMatched: boolean = false;
         item.appointmentTypes.some(item =>
            appointmentTypes.some((selectedType: string) => {
               if (
                  selectedType.toLowerCase() ===
                     item.appointmentTypeDescription.toLocaleLowerCase() &&
                  item.appointmentsRemaining > 0
               ) {
                  isMatched = true;
               }
            }),
         );
         return isMatched;
      }
   } catch (err) {
      console.error(err);
      return false;
   }
};

const mileFilter = (item: IBloodDrive, distanceInMiles: number): boolean => {
   const meterToMilesConversion = 0.000621371;

   if (item?.location?.distanceFromOriginMeters) {
      const convertedDistance: string = (
         item?.location?.distanceFromOriginMeters * meterToMilesConversion
      ).toFixed(2);
      return Number(convertedDistance) <= distanceInMiles;
   }
   return true;
};

// SCREDP-42: filters for account code, account name, location code, private
const accountCodeFilter = (item: IBloodDrive, accountCode: string): boolean => {
   if (!accountCode) return true;
   return item.account.accountCode === accountCode;
};

const accountNameFilter = (item: IBloodDrive, accountName: string): boolean => {
   if (!accountName) return true;
   return item.account.accountName.toLowerCase().includes(accountName.toLowerCase());
};

const locationCodeFilter = (item: IBloodDrive, locationCode: string): boolean => {
   if (!locationCode) return true;
   return item.location.locationCode === locationCode;
};

const privateFilter = (item: IBloodDrive, isPrivate: Boolean): boolean => {
   if (isPrivate === undefined) return true;
   return item.location.private === isPrivate.valueOf();
};

const opportunityLocatorFilters = (
   item: IBloodDrive,
   filter: IOpportunitySearchFilter,
): boolean | undefined => {
   try {
      const baseFilters = accountCodeFilter(item, filter.accountCode) && locationCodeFilter(item, filter.locationCode) &&
      appointmentTypeFilter(
         item,
         filter.selectedAppointmentTypes || [],
      ) &&
      dateFilter(
         filter.startDate,
         filter.endDate,
         new Date(item.startTime),
      ) && locationFilter(item.location, filter.locationType) && 
      privateFilter(item, filter.isPrivate);

      if (filter.searchType === LocationOrAccountOptions.LOCATION) {
         return baseFilters && accountNameFilter(item, filter.accountName) && mileFilter(item, Number(filter.radiusMiles));
      } else {
         return baseFilters;
      }
   } catch (err) {
      console.error("Error Occurred While Filtering Results");
   }
};

export const getFilteredData = (
   drives: IBloodDrive[],
   filters: IOpportunitySearchFilter,
): IBloodDrive[] => {
   try {
      const filteredDrives: IBloodDrive[] = drives.filter(item => {
         return opportunityLocatorFilters(item, filters);
      });

      if (filteredDrives.length === 0) {
         return [];
      } else {
         switch (filters.sortBy) {
            case SortBy.ALPHABETICAL_ORDER:
               return alphabeticalSorting(filteredDrives);
            case SortBy.DISTANCE_ORDER:
               return distanceSorting(filteredDrives);
            case SortBy.CHRONOLOGICAL_ORDER:
               return chronologicalOrder(filteredDrives);
            default:
               console.error("Unsupported sorting method");
               return chronologicalOrder(filteredDrives);
         }
      }
   } catch (err) {
      return [];
   }
};
